<template>
  <div>
    <ed-table
    :key="$root.$session.versao"
       strModel="Cadastro/Funcao"
      :headers="arrayHeaders"
      :rows="arrayRows"
      :pagination="objPagination"
      :filter="formFiltros"
      :loading="loading"
      @register="onRegister"
      @edit="onEdit"
      @search="getFuncao"
    />
  </div>
</template>

<script>
import { EdTable } from "@/components/common/form";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdTable },
  mounted() {
    this.getFuncao();
  },
  beforeDestroy() {
    this.arrayHeaders = [];
    this.arrayRows = [];
    this.objPagination = null;
  },
  created() {},
  data() {
    return {
      loading: false,
      arrayHeaders: [
        {
          text: "CBO",
          sortable: true,
          value: "strCbo",
        },
        {
          text: "Nome",
          sortable: true,
          value: "strNome",
        },
        {
          text: "Descrição",
          sortable: true,
          collapse: 50,
          value: "strDescricao",
        },
      ],
      arrayRows: [],
      objPagination: null,
      formFiltros:{}
    };
  },
  methods: {
    onRegister() {
      this.$router.push({ name: "cadastro.funcao.register" });
    },

    onEdit(data) {
      this.$router.push({
        name: "cadastro.funcao.edit",
        params: { intId: data.intId },
      });
    },

    getFuncao() {
      this.loading = true;
      this.arrayRows = [];

      this.$root.$request.get("Cadastro/Funcao", this.formFiltros).then((objResult) => {
        if (objResult.status == 200) {
          this.objPagination = objResult.result;
          this.loading = false;

          objResult.result.data.forEach((objFuncao) => {
            let item = {
              intId: objFuncao.intId,
              strCbo: objFuncao.strCbo,
              strNome: objFuncao.strNome,
              strDescricao: objFuncao.strDescricao,
              _item: objFuncao,
            };

            this.arrayRows.push(item);
          });
        }
      });
    },
  },
};
</script>
